import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListLoaderComponent } from '../list-loader.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { VirtualScrollModule } from 'ZalamoLibrary/src/lib/ui/virtual-scroll/virtual-scroll.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollbarCdkVirtualScroll } from 'ngx-scrollbar/cdk';

@NgModule({
  declarations: [ListLoaderComponent],
  exports: [ListLoaderComponent],
  imports: [
    CommonModule,
    MatProgressBarModule,
    VirtualScrollModule,
    NgScrollbarModule, NgScrollbarCdkVirtualScroll,
  ],
})
export class ListLoaderModule {}
